import { useState, useEffect } from 'react';
import { educationService } from '../services/dataService';

/**
 * Custom hook to fetch education data from Firestore
 * @returns {Object} { education, loading, error, refetch }
 */
export const useEducation = () => {
  const [education, setEducation] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEducation = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await educationService.getAll();
      
      if (result.success) {
        // Sort by order field
        const sortedEducation = result.data.sort((a, b) => (a.order || 0) - (b.order || 0));
        setEducation(sortedEducation);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEducation();
  }, []);

  return {
    education,
    loading,
    error,
    refetch: fetchEducation
  };
};